const DAY_IN_MILLISECONDS = 1 * 24 * 60 * 60 * 1000;
export function addBusinessDays(date: Date, daysToAdd: number): Date {
  let newDate = date;
  let workDay = 0;
  let moreDays = true;
  while (moreDays) {
    newDate = new Date(newDate.getTime() + DAY_IN_MILLISECONDS);
    if (newDate.getDay() > 0 && newDate.getDay() < 6) {
      workDay++;
      if (workDay >= daysToAdd) {
        moreDays = false;
      }
    }
  }
  return newDate;
}
